// removed by extract-text-webpack-plugin
module.exports = {"container":"_27CKvfK8EUH-B8LsIZ7IJ","icon":"_300qyFAJlAOSk2uACtF7RR"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/CoinCircle/styles.css
// module id = 1491
// module chunks = 83